const styles = {
  interactivePrompt: "agent-gui-conversation__interactive-prompt",
  interactivePromptCard: "agent-gui-conversation__interactive-prompt-card",
  interactivePromptHeader: "agent-gui-conversation__interactive-prompt-header",
  interactivePromptLeadContent:
    "agent-gui-conversation__interactive-prompt-lead-content",
  interactivePromptLead: "agent-gui-conversation__interactive-prompt-lead",
  interactivePromptMeta: "agent-gui-conversation__interactive-prompt-meta",
  interactivePromptQuestion:
    "agent-gui-conversation__interactive-prompt-question",
  interactivePromptOptions:
    "agent-gui-conversation__interactive-prompt-options",
  interactiveOptionDisplay:
    "agent-gui-conversation__interactive-option-display",
  interactiveOptionButton: "agent-gui-conversation__interactive-option-button",
  interactiveOptionContent:
    "agent-gui-conversation__interactive-option-content",
  interactiveOptionTitle: "agent-gui-conversation__interactive-option-title",
  interactiveOptionDescription:
    "agent-gui-conversation__interactive-option-description",
  interactiveOptionCommandDescription:
    "agent-gui-conversation__interactive-option-command-description",
  interactiveOptionCommandTooltip:
    "agent-gui-conversation__interactive-option-command-tooltip",
  interactiveOptionShortcut:
    "agent-gui-conversation__interactive-option-shortcut",
  interactiveOptionSpinner:
    "agent-gui-conversation__interactive-option-spinner",
  interactiveFeedbackComposer:
    "agent-gui-conversation__interactive-feedback-composer",
  interactivePromptTextarea:
    "agent-gui-conversation__interactive-prompt-textarea",
  interactiveFeedbackSendButton:
    "agent-gui-conversation__interactive-feedback-send-button",
  interactivePromptFooter: "agent-gui-conversation__interactive-prompt-footer",
  interactivePromptActions:
    "agent-gui-conversation__interactive-prompt-actions",
  interactivePromptCollapsed:
    "agent-gui-conversation__interactive-prompt-collapsed",
  userMessageFlow: "agent-gui-conversation__user-message-flow",
  assistantMessageFlow: "agent-gui-conversation__assistant-message-flow",
  participantMessageLayout:
    "agent-gui-conversation__participant-message-layout",
  participantMessageHeader:
    "agent-gui-conversation__participant-message-header",
  participantName: "agent-gui-conversation__participant-name",
  participantMessageContent:
    "agent-gui-conversation__participant-message-content",
  participantAvatar: "agent-gui-conversation__participant-avatar",
  messageGroup: "agent-gui-conversation__message-group",
  messageFooter: "agent-gui-conversation__message-footer",
  messageTimestamp: "agent-gui-conversation__message-timestamp",
  messageCopyButton: "agent-gui-conversation__message-copy-button",
  userImageGrid: "agent-gui-conversation__user-image-grid",
  userImageThumbnail: "agent-gui-conversation__user-image-thumbnail",
  userMessageBubble: "agent-gui-conversation__user-message-bubble",
  userMessageEditor: "agent-gui-conversation__user-message-editor",
  userMessageEditorTextarea:
    "agent-gui-conversation__user-message-editor-textarea",
  userMessageEditorActions:
    "agent-gui-conversation__user-message-editor-actions",
  assistantMarkdown: "agent-gui-conversation__assistant-markdown"
} as const;

export default styles;
